/*=============================================== Search component ===============================================*/

import { useState, useRef, useEffect } from "react"
import type { FormEvent } from "react"
import { createSearchParams, useNavigate } from "react-router-dom"
import {
    Icon,
    Key,
    Modal,
    Autocomplete,
    Button,
    Flexbox,
    useKeyPress,
    useClickOutside,
    disableScroll,
    enableScroll,
    unslugify,
    useMaxWidth,
    ButtonIcon,
} from "tsx-library-julseb"

import {
    StyledSearch,
    OpenSearch,
    IconContainer,
    SearchPlaceholder,
} from "components/layouts/Search/styles"

import { allPages } from "data"
import { fuseOptions } from "config"

const Search = () => {
    const isMobile = useMaxWidth(600)

    const [isOpen, setIsOpen] = useState(false)
    const [search, setSearch] = useState("")

    const inputRef = useRef<HTMLInputElement>(null)
    const formRef = useRef<HTMLFormElement>(null)

    const handleClose = () => {
        setIsOpen(false)
        setSearch("")
    }

    useKeyPress(() => {
        if (isOpen) handleClose()
        else setIsOpen(true)
    }, ["Command", "KeyK"])

    useKeyPress(() => {
        if (isOpen) handleClose()
    }, ["Escape"])

    const onClickOutside = () => handleClose()
    useClickOutside(formRef, onClickOutside)

    useEffect(() => {
        if (isOpen) {
            inputRef?.current?.focus()
            disableScroll()
        } else {
            enableScroll()
        }
    }, [isOpen])

    const navigate = useNavigate()

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()

        navigate({
            pathname: "/search-results",
            search: createSearchParams({
                query: search,
            }).toString(),
        })

        handleClose()
    }

    const pages = allPages?.map(page => unslugify(page.title))

    return (
        <>
            {isMobile ? (
                <ButtonIcon
                    icon="search"
                    size={24}
                    variant="transparent"
                    color="white"
                    onClick={() => setIsOpen(true)}
                />
            ) : (
                <OpenSearch onClick={() => setIsOpen(true)}>
                    <IconContainer>
                        <Icon src="search" size={16} />
                    </IconContainer>
                    <SearchPlaceholder>Search component...</SearchPlaceholder>
                    <Key keys={["⌘", "K"]} />
                </OpenSearch>
            )}

            <Modal isOpen={isOpen} setIsOpen={setIsOpen} disableEsc>
                <StyledSearch onSubmit={handleSubmit} ref={formRef}>
                    <Autocomplete
                        items={pages}
                        value={search}
                        setValue={setSearch}
                        label="Search components globally"
                        ref={inputRef}
                        fuzzyOptions={fuseOptions}
                    />

                    <Flexbox alignItems="center" gap="xs">
                        <Button type="submit">Search</Button>
                        <Button variant="transparent" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Flexbox>
                </StyledSearch>
            </Modal>
        </>
    )
}

export default Search
